import styled, { css } from 'styled-components';

export const ExtoleIframe = styled.iframe`
  ${({ $height }) => css`
      width: 100%;
      height: ${$height}px;
      min-height: ${$height}px;
      border: none;
      display: block;
      overflow: hidden;
    `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-left: 48px;
  padding-right: 48px;
`;
